import {
  REMOVAL_BEYOND_SCOPE,
  REMOVAL_BEYOND_SCOPE_NAMES,
  type SpecialRemovalRow,
} from '../constants/excavation-material.constants';

function parsePositiveNumber(raw: unknown): number | undefined {
  if (raw == null || raw === '') return undefined;
  const n = typeof raw === 'number' ? raw : Number(String(raw).replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n : undefined;
}

function formatDisplayNumber(n: number): string {
  const rounded = Math.round(n * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}

function asSpecialRemovalRow(raw: unknown): SpecialRemovalRow | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const o = raw as Record<string, unknown>;
  const code = typeof o['code'] === 'string' ? o['code'].trim() : '';
  const lengthM = parsePositiveNumber(o['lengthM']);
  if (!code || lengthM == null) return null;
  const widthM = parsePositiveNumber(o['widthM']) ?? 0;
  const depthM = parsePositiveNumber(o['depthM']);
  return { code, lengthM, widthM, ...(depthM != null ? { depthM } : {}) };
}

/** Jedna položka bourání / rozvoz — český název a rozměry (šířka × délka × hloubka u betonu). */
export function formatSpecialRemovalRowForDisplay(raw: unknown): string | null {
  const row = asSpecialRemovalRow(raw);
  if (!row) return null;
  const label = REMOVAL_BEYOND_SCOPE_NAMES[row.code] ?? row.code;
  const widthM = parsePositiveNumber(row.widthM);
  const lengthM = parsePositiveNumber(row.lengthM);
  const depthM = parsePositiveNumber(row.depthM);

  if (
    row.code === REMOVAL_BEYOND_SCOPE.BOURANI_BETON_ZAKLADY &&
    widthM != null &&
    lengthM != null &&
    depthM != null
  ) {
    return `${label}: ${formatDisplayNumber(widthM)}×${formatDisplayNumber(lengthM)}×${formatDisplayNumber(depthM)} m`;
  }
  if (widthM != null && lengthM != null) {
    return `${label}: ${formatDisplayNumber(widthM)}×${formatDisplayNumber(lengthM)} m`;
  }
  if (lengthM != null) {
    return `${label}: ${formatDisplayNumber(lengthM)} m`;
  }
  return label;
}

/** Všechny řádky `specialRemovalRows[]` — pro výkaz práce, historii, deník. */
export function formatSpecialRemovalRowsForDisplay(
  rows: unknown,
  separator = ' · ',
): string | undefined {
  if (!Array.isArray(rows) || rows.length === 0) return undefined;
  const parts = rows
    .map((row) => formatSpecialRemovalRowForDisplay(row))
    .filter((part): part is string => Boolean(part));
  return parts.length > 0 ? parts.join(separator) : undefined;
}
